import React from "react";
import { Reveal, SectionHeading } from "@/components/common";
import PhoneMock from "@/components/PhoneMock";

const ITEMS = [
  { variant: "payment", label: "Project payment link", desc: "Scope, milestones and a secure Stripe payment in one page." },
  { variant: "milestone", label: "Milestone tracking", desc: "Live progress and daily payouts for approved milestones." },
  { variant: "approval", label: "Customer approvals", desc: "Customers approve work before each release." },
  { variant: "dispute", label: "Dispute documentation", desc: "Proof and messages kept organized around the project." },
];

export const AppShowcase = ({
  overline = "Inside the app",
  title = "See every project, milestone and payout.",
  subtitle = "A clean, professional experience for vendors and customers — from the first payment link to the final approved milestone.",
  dark = false,
}) => (
  <section
    data-testid="app-showcase"
    className={`relative py-16 sm:py-24 overflow-hidden ${dark ? "bg-[#091630]" : "bg-[#f7faf8]"}`}
  >
    {dark && (
      <>
        <div className="absolute -top-24 -left-24 h-96 w-96 rounded-full bg-[#21c55e]/15 blur-3xl" />
        <div className="absolute inset-0 dotted-bg opacity-[0.1]" />
      </>
    )}
    <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <Reveal>
        <SectionHeading overline={overline} title={title} subtitle={subtitle} center onDark={dark} />
      </Reveal>

      <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
        {ITEMS.map((it, i) => (
          <Reveal key={it.variant} delay={(i % 4) * 0.08}>
            <div className="flex flex-col items-center text-center">
              <PhoneMock variant={it.variant} />
              <h3 className={`font-display text-base font-bold mt-7 ${dark ? "text-white" : "text-[#091630]"}`}>
                {it.label}
              </h3>
              <p className={`text-sm mt-1.5 max-w-[230px] leading-relaxed ${dark ? "text-slate-400" : "text-slate-500"}`}>
                {it.desc}
              </p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);

export default AppShowcase;
